import _ from "lodash";
import defaultThumbnail from '../assets/thumbnail/default-thumbnail.png';

import default_thumbnail_84_64 from '../assets/thumbnail/default_thumbnail_84_64.jpg';
import default_thumbnail_427_240 from '../assets/thumbnail/default_thumbnail_427_240.jpg';
import default_thumbnail_640_360 from '../assets/thumbnail/default_thumbnail_640_360.jpg';
import default_thumbnail_853_480 from '../assets/thumbnail/default_thumbnail_853_480.jpg';
import default_thumbnail_1280_720 from '../assets/thumbnail/default_thumbnail_1280_720.jpg';
import default_thumbnail1902_1080 from '../assets/thumbnail/default_thumbnail1902_1080.jpg';
import default_thumbnail_1920_1080 from '../assets/thumbnail/default_thumbnail_1920_1080.jpg';

export const CommonHelper = {
  hasRole,
  linkValidation,
  setVideoInformation,
  getQueryStrings,
  modalHeightAndApperance,
  paginationNoOfRows,
  defaultThumbnailUrls
};

function hasRole(user, roles) {
  return roles.some(role => user.roles.includes(role));
}

function linkValidation(value) {
  let hostname = value.replace(/^((\w+:)?\/\/[^\/]+\/?).*$/,'$1');
  let lowercaseURL = hostname.toLowerCase();
  let UrlRegexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  if (UrlRegexp.test(lowercaseURL)) {
    return true;
  }
  else {
    return false;
  }
} 

function setVideoInformation(videos, thumbnailUrls, tags) {
  return new Promise((resolve, reject) => {
    for (let index = 0; index < videos.length; index++) {
      //set thumbnailUrls
      videos[index].thumbnailUrls = _.filter(thumbnailUrls, ['videoId', videos[index].videoId]);
      if (videos[index].thumbnailUrls) {
        if (videos[index].thumbnailUrls.length == 1) {
          videos[index].thumbnailUrl = videos[index].thumbnailUrls[0].thumbnailUrl;
        }
        if (videos[index].thumbnailUrls.length > 1) {
          videos[index].thumbnailUrl = videos[index].thumbnailUrls[1].thumbnailUrl;
        }
      } else {
        videos[index].thumbnailUrl = defaultThumbnail;
      }
      ////set tags
      videos[index].tags = _.filter(tags, ['videoId', videos[index].videoId]);
    }
    resolve(videos);
  });
};

function getQueryStrings(splitString) {
  if (splitString) {
    return decodeURI(window.location.search)
      .replace('?', '')
      .split(splitString)
      .map(param => param.split('='))
      .reduce((values, [key, value]) => {
        values[key] = value
        return values
      }, {});
  } else {
    return decodeURI(window.location.search)
      .replace('?', '')
      .split('&')
      .map(param => param.split('='))
      .reduce((values, [key, value]) => {
        values[key] = value
        return values
      }, {});
  }
};

function modalHeightAndApperance(scrollWithPage, footerVisible){
  document.querySelector('.modalOverlay').style.paddingTop = window.customObj;
  // const modalBody = document.getElementsByClassName('modalBody')[0];
  // const headerCloseButton = document.getElementsByClassName('modalClose')[0];
  // const modalContent = document.getElementsByClassName('modalContent')[0];
  // const modalOverlay = document.getElementsByClassName('modalOverlay')[0];
  // const header = document.getElementsByClassName('modalHeader')[0];
  // const footer = document.getElementsByClassName('modalFooter')[0];
  // // apply padding based on clientHeight...
  // const windowHeight  = window.innerHeight;
  // const paddingHeight = (windowHeight - modalContent.offsetHeight) / 2;
  // const headerHeight  = header.getBoundingClientRect().height;
  // const footerHeight  = footer ? footer.getBoundingClientRect().height : 0;
  // modalBody.style.maxHeight = (scrollWithPage || !footerVisible)
  //   ? 'none' : `${windowHeight - (headerHeight + footerHeight + 120)}px`;
  // modalOverlay.style.paddingTop = paddingHeight > 20 ? `${paddingHeight}px` : '20px';
  // // conditional borders on modalbody if scrollbar is present...
  // modalBody.className = (modalBody.offsetHeight < modalBody.scrollHeight && !headerCloseButton) ? 'modalBody modalBody_border' : 'modalBody modalBody_border_normal';
}

function paginationNoOfRows(){
  let width = window.innerWidth;
  if(width >= 1450){
    return 15;
  }
  else if(width >= 1280){
    return 12;
  }
  else if(width >= 992){
    return 9;
  }
  else if(width >= 768){
    return 6;
  }
  else if(width >= 480){
    return 6;
  }
  else if(width >= 320){
    return 3;
  }
  return 9;
}

function defaultThumbnailUrls() {

  return [
    {
      "id": 0,
      "size": "64",
      "thumbnailUrl": default_thumbnail_84_64,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "240",
      "thumbnailUrl": default_thumbnail_427_240,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "360",
      "thumbnailUrl": default_thumbnail_640_360,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "480",
      "thumbnailUrl": default_thumbnail_853_480,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "720",
      "thumbnailUrl": default_thumbnail_1280_720,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "1080",
      "thumbnailUrl": default_thumbnail1902_1080,
      "isActive": 1
    },
    {
      "id": 0,
      "size": "1080",
      "thumbnailUrl": default_thumbnail_1920_1080,
      "isActive": 1
    }
  ]
}



// WEBPACK FOOTER //
// ./src/_helpers/common.js